// The stylesheet goes in the page's <head>, not the shadow root: @font-face only registers at document level,
// and the shadow root still uses it. Same name rule as EventFormTheme::FAMILY.
const FAMILY = /^[\w -]{1,80}$/

// CSS has no `display` or `handwriting` generic family: mirrors EventFormTheme::GENERIC_FAMILY, so the
// fallback while a Google face loads is a real CSS keyword instead of always "sans-serif".
const GENERIC_FAMILY = { display: 'sans-serif', handwriting: 'cursive' }

export function googleFontStack(family, category = 'sans-serif') {
  const name = (family || '').trim()
  if (!FAMILY.test(name)) return 'inherit'
  return `"${name}", ${GENERIC_FAMILY[category] || category || 'sans-serif'}`
}

// No weights in the URL: css2 refuses the whole request when a family lacks one (Lobster is 400 only).
// Keep in step with PartyInquiries::PageTheme::FONT_URL, which links the same URL on the event proposal page.
export function loadGoogleFont(family) {
  const name = (family || '').trim()
  if (!FAMILY.test(name)) return
  const href = `https://fonts.googleapis.com/css2?family=${name.replace(/ /g, '+')}&display=swap`
  if ([...document.head.querySelectorAll('link[rel="stylesheet"]')].some((link) => link.href === href)) return
  document.head.append(Object.assign(document.createElement('link'), { rel: 'stylesheet', href }))
}
